export type ThemeName = 'glassmorphism' | 'minimal' | 'futuristic';
export type LayoutName = 'A' | 'B' | 'C' | 'D' | 'E';

export interface SiteConfig {
  currentTheme: ThemeName;
  currentLayout: LayoutName;
}

export const defaultConfig: SiteConfig = {
  currentTheme: 'glassmorphism',
  currentLayout: 'A',
};

export const themeLabels: Record<ThemeName, string> = {
  glassmorphism: 'Glassmorphism',
  minimal: 'Minimal',
  futuristic: 'Futuristic',
};

export const layoutLabels: Record<LayoutName, string> = {
  A: 'Classic Full-Width',
  B: 'Split Hero',
  C: 'Card Over Image',
  D: 'Minimal Text',
  E: 'Video Hero',
};

export const layoutDescriptions: Record<LayoutName, string> = {
  A: 'Full-bleed hero with centered CTA',
  B: 'Text left, image right split layout',
  C: 'Floating card over hero image',
  D: 'Clean, text-focused minimal hero',
  E: 'Video placeholder with overlay',
};
